// src/components/ui/Button.jsx

import React from 'react';
import { getButtonStyle } from './theme';

export default function Button({
  variant = 'primary',
  size = 'md',
  refreshing = false,
  disabled = false,
  active = false,
  type = 'button',
  style,
  children,
  ...rest
}) {
  const isDisabled = disabled || refreshing;

  return (
    <button
      type={type}
      disabled={isDisabled}
      style={{
        ...getButtonStyle(variant, { size, refreshing, disabled: isDisabled, active }),
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}
